import React from "react";

interface UtilityBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
  onFilter?: () => void;
  filterLabel?: string;
}

export const UtilityBar: React.FC<UtilityBarProps> = ({
  searchValue,
  onSearchChange,
  placeholder = "Search documents, IDs, or dates...",
  onFilter,
  filterLabel = "Filter results",
}) => {
  return (
    <div className="vault-utility-bar">
      <div className="vault-search-wrap">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          className="vault-search-input"
          type="text"
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      {onFilter && (
        <div className="vault-view-controls">
          <button className="vault-control-btn" onClick={onFilter}>
            {filterLabel}
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};
